export const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID
export const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID
export const publicKey= process.env.REACT_APP_EMAILJS_PUBLIC_KEY